<template>
  <div class="full">
    <div tabindex="-1" id="chat-output" class="maximizer" ref="mathJaxEl" v-html="output"></div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {}
  },
  data () {
    return {
      output: '',
      latex: ''
    }
  },
  mounted () {
    this.renderLatex()
  },
  methods: {
    renderLatex () {
      this.latex = `${this.msg.text}`
      this.renderOutput()
    },
    renderOutput () {
      if (this.latex) {
        this.output = this.latex
        this.$forceUpdate()
        this.$nextTick(() => {
          window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, this.$refs['mathJaxEl']])
        })
      }
    }
  }
}
</script>

<style scoped>
.maximizer{
  overflow: auto;
}
</style>
